export default __webpack_public_path__ + "static/media/msk-libraries.f8f36db2.png";